import { API_DOMAIN } from "../constants";

// ── AI assistant API paths ────────────────────────────────────────────────
// All require the standard accessToken header, auto-attached by
// axiosSetup.js's request interceptor for same-origin calls — no need to
// pass headers explicitly at each call site.
export const AI_CONFIG_API = `${API_DOMAIN}/ai/config`;
export const AI_CHATS_API = `${API_DOMAIN}/ai/chats`;
// Admin-only on the backend (403 for everyone else) — only fetch this when
// the signed-in user is actually an admin.
export const AI_PROVIDERS_API = `${API_DOMAIN}/ai/providers`;
export const aiChatApi = (chatId) => `${API_DOMAIN}/ai/chats/${chatId}`;
export const aiChatMessagesApi = (chatId) => `${API_DOMAIN}/ai/chats/${chatId}/messages`;
export const aiChatMessagesStreamApi = (chatId) => `${API_DOMAIN}/ai/chats/${chatId}/messages/stream`;
export const aiChatAttachmentsApi = (chatId) => `${API_DOMAIN}/ai/chats/${chatId}/attachments`;
// Takes the id of a status:'failed' message (user OR assistant — a failed
// streaming generation always ends with the assistant row marked 'failed',
// so pass that id; the backend resolves the source prompt itself). Streams
// the same way a regular send does (202 + {generation_id, user_message,
// assistant_message} placeholder, then the usual ai:message_stream_*
// events) — confirmed fixed on the backend 2026-07-20. The failed source
// exchange is left untouched; retry always inserts a new user+assistant pair.
export const aiMessageRetryApi = (messageId) => `${API_DOMAIN}/ai/messages/${messageId}/retry`;

// Attachment-registration chain shared with the rest of this backend
// (image_upload -> uploads/register), plus the AI-specific "attachment_type"
// value the backend registered in uzd_misc.mode='attachment_types' for
// this feature (image-only for now — see FUTURE_TASKS.md).
export const IMAGE_UPLOAD_API = `${API_DOMAIN}/whatsapp/image_upload`;
export const UPLOADS_REGISTER_API = `${API_DOMAIN}/uploads/register`;
export const AI_CHAT_ATTACHMENT_TYPE = "ai_chat_attachment";
export const AI_CHAT_UPLOADED_FOR = "ai_chat";
export const aiChatArchiveApi = (chatId) => `${API_DOMAIN}/ai/chats/${chatId}/archive`;
export const aiChatRestoreApi = (chatId) => `${API_DOMAIN}/ai/chats/${chatId}/restore`;

// Exact 409 body text the backend returns for a second concurrent send on
// the same chat — matched defensively, but the HTTP status itself (409) is
// what call sites should actually branch on.
export const AI_CONCURRENT_REQUEST_MESSAGE = "Another request is already running.";

// WATI image AI analysis — fully independent of the AI Assistant chat flow
// above (separate ai_media_analyses table, no LM Studio persistence, no
// generation_id/streaming). Synchronous request/response.
export const aiMediaAnalysisByMessageApi = (watiMessageId) => `${API_DOMAIN}/ai/media-analyses/by-message/${watiMessageId}`;
export const AI_MEDIA_ANALYZE_API = `${API_DOMAIN}/ai/media-analyses/analyze`;
